export default __webpack_public_path__ + "static/banner-087c3ace95110e89435589519301760c.png";